var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16c-1.42 0-2.31-3-3.1-5.64C17.92 7.09 17 4 14.83 4s-3.09 3.09-4.06 6.36C10 13 9.08 16 7.66 16s-2.31-3-3.1-5.64c-.9-3-1.75-5.85-3.56-6.29V.5A.5.5 0 00.5 0a.5.5 0 00-.5.5V21a1 1 0 001 1h20.5a.5.5 0 000-1H1V5.13c1.14.6 1.91 3.19 2.6 5.51C4.58 13.91 5.5 17 7.66 17s3.09-3.09 4.07-6.36C12.52 8 13.41 5 14.83 5s2.32 3 3.11 5.64c1 3.27 1.9 6.36 4.06 6.36a.5.5 0 000-1z",
    "data-name": "Layer 2"
  })));
}
export default SvgAnalytics;